import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ over, title, sub }) => (
  <Reveal className="mb-12 sm:mb-16 max-w-3xl">
    <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-[#00E5FF]">{over}</p>
    <h2 className="font-display text-4xl sm:text-6xl font-black uppercase leading-[0.95] tracking-tight text-white">{title}</h2>
    {sub && <p className="mt-5 text-base md:text-lg text-slate-300">{sub}</p>}
  </Reveal>
);
